import * as Api from '@ViewModels';
import * as React from 'react';
import { reaction } from 'mobx';
import { AppState } from '../../models/AppState';

/**
 * Reactively reads the WebSocket connection status from AppState.websockets.
 * Updates whenever the underlying MobX observable changes.
 * Returns undefined if websockets is not yet initialized.
 */
export const useWebsocketConnectionStatus = (): Api.RemoteEventsConnectionStatus | undefined => {
	// Lazy initializer seeds the initial value synchronously (no re-render needed).
	const [status, setStatus] = React.useState<Api.RemoteEventsConnectionStatus | undefined>(
		() => AppState.websockets?.connectionStatus
	);

	React.useEffect(() => {
		// AppState.websockets is initialized at app startup before components mount.
		// If it is null here, no reaction is registered and the hook returns undefined,
		// which is the correct behaviour (no WebSocket connection exists).
		if (!AppState.websockets) return;

		const dispose = reaction(
			() => AppState.websockets?.connectionStatus,
			newStatus => setStatus(newStatus)
		);

		return dispose;
	}, []);

	return status;
};
